module.exports = __webpack_public_path__ + "img/second-place.29eb6da0.svg";